import { render, staticRenderFns } from "./editGameForm.vue?vue&type=template&id=67940bc7&"
import script from "./editGameForm.vue?vue&type=script&lang=js&"
export * from "./editGameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports